import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { chatGetSessionQueryKey, markDraftApplied } from "@/api";
import { useCurrentUser } from "@/features/account/useCurrentUser";
import { useDraftContext } from "./DraftContext";

/** What every card's Create needs: the chat to link, the team to create in, and a refresh of the chat's links. */
export function useDraftActions() {
  const { t } = useTranslation("buildChat", { keyPrefix: "draft" });
  const { sessionUuid } = useDraftContext();
  const me = useCurrentUser();
  const queryClient = useQueryClient();
  // The form's rule: the Everyone team, else the first team.
  const teams = me.data?.teams ?? [];
  const teamUuid = (teams.find((tm) => tm.team.isEveryone) ?? teams[0])?.team.uuid ?? null;
  return {
    sessionUuid,
    teamUuid,
    noTeam: t("noTeam"),
    /** Records on the draft what its card created or saved (the chat's owner only; cards are read-only otherwise). */
    markApplied: (draftId: string, entityUuid: string) =>
      sessionUuid
        ? markDraftApplied({
            path: { session_uuid: sessionUuid, draft_id: draftId },
            body: { entityUuid },
            throwOnError: true,
          })
        : Promise.resolve(),
    /** The record and linked entities come with the chat: refetch it so the card reads right after a reload too. */
    refreshChat: () =>
      sessionUuid
        ? queryClient.invalidateQueries({ queryKey: chatGetSessionQueryKey({ path: { session_uuid: sessionUuid } }) })
        : Promise.resolve(),
  };
}
